module.exports = __webpack_public_path__ + "19803c2b3e848a4547ec8bf6e6e7b0e6.svg";